import React, { useState } from "react";
import "./Contact.css";
import { BsPhone } from "react-icons/bs";
import { MdMarkEmailRead } from "react-icons/md";
import { SlLocationPin } from "react-icons/sl";
import { IoSend } from "react-icons/io5";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const sendMessage = (e) => {
    e.preventDefault();
    if (name.trim() != "" && message.trim() != "") {
      const msg = {
        name,
        email,
        message,
      };
      window.open(
        `https://wa.me/7350403908?text=${name} ${email} ${message}`,
        "_blank"
      );
    } else {
      window.alert("All Filed Required..!!");
    }
  };
  return (
    <section className="contact section" id="contact">
      <br />
      <br />
      <h2 className="section__title">Contact Me</h2>
      <span className="section__subtitle">Get in touch</span>
      <div className="contact__container container grid">
        <div>
          <div className="contact__information">
            <i className="contact__icon">
              <BsPhone />
            </i>
            <div>
              <h3 className="contact__title">Call Me</h3>
              <span className="contact__subtitle">+91 7350403908</span>
            </div>
          </div>

          <div className="contact__information">
            <i className="contact__icon">
              <MdMarkEmailRead />
            </i>
            <div>
              <h3 className="contact__title">Email</h3>
              <span className="contact__subtitle">
                khamkarpradip20@gmail.com
              </span>
            </div>
          </div>
          <div className="contact__information">
            <i className="contact__icon">
              <SlLocationPin />
            </i>
            <div>
              <h3 className="contact__title">Location</h3>
              <span className="contact__subtitle">Pune - Maharashtra</span>
            </div>
          </div>
        </div>
        <form className="contact__form grid" onSubmit={(e) => sendMessage(e)}>
          <div className="contact__input grid">
            <div className="contact__content">
              <label htmlFor="" className="contact__label">
                Name
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="contact__input"
              />
            </div>
            <div className="contact__content">
              <label htmlFor="" className="contact__label">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="contact__input"
              />
            </div>
            <div className="contact__content">
              <label htmlFor="" className="contact__label">
                Message
              </label>
              <textarea
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                }}
                cols="0"
                rows="7"
                className="contact__input"
              ></textarea>
            </div>
          </div>
          <button className="button button--flex contact__btn" type="submit">
            Send Message
            <i className="button__icon send__message-icon ">
              <IoSend />
            </i>
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
